
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * SocialTradingOrderInvestorUpdate struct
 */
class SocialTradingOrderInvestorUpdate {
  /**
   * Initialize struct
   * @param {number=} masterOrderId
   * @param {number=} masterLogin
   * @constructor
   */
  constructor (masterOrderId = null, masterLogin = null) {
    this.MasterOrderId = masterOrderId
    this.MasterLogin = masterLogin
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SocialTradingOrderInvestorUpdate}
   * @param {!SocialTradingOrderInvestorUpdate} other Other struct
   * @returns {!SocialTradingOrderInvestorUpdate} This struct
   */
  copy (other) {
    if (other.MasterOrderId != null) {
      this.MasterOrderId = UInt64.fromNumber(other.MasterOrderId)
    } else {
      this.MasterOrderId = null
    }
    if (other.MasterLogin != null) {
      this.MasterLogin = UInt64.fromNumber(other.MasterLogin)
    } else {
      this.MasterLogin = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SocialTradingOrderInvestorUpdate}
   * @returns {!SocialTradingOrderInvestorUpdate} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SocialTradingOrderInvestorUpdateModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SocialTradingOrderInvestorUpdateModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SocialTradingOrderInvestorUpdate}
   * @param {!SocialTradingOrderInvestorUpdate} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SocialTradingOrderInvestorUpdate)) {
      throw new TypeError('Instance of SocialTradingOrderInvestorUpdate is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SocialTradingOrderInvestorUpdate}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      MasterOrderId: ((this.MasterOrderId != null) ? this.MasterOrderId.toNumber() : null),
      MasterLogin: ((this.MasterLogin != null) ? this.MasterLogin.toNumber() : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SocialTradingOrderInvestorUpdate.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SocialTradingOrderInvestorUpdate} other Object value
   * @returns {!SocialTradingOrderInvestorUpdate} Created struct
   */
  static fromObject (other) {
    return new SocialTradingOrderInvestorUpdate().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SocialTradingOrderInvestorUpdate}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SocialTradingOrderInvestorUpdate.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SocialTradingOrderInvestorUpdate}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4168
  }
}

export { SocialTradingOrderInvestorUpdate };

/**
 * Fast Binary Encoding SocialTradingOrderInvestorUpdate field model
 */
class FieldModelSocialTradingOrderInvestorUpdate extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.MasterOrderId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, 4 + 4), buffer, 4 + 4)
    this.MasterLogin = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.MasterOrderId.fbeOffset + this.MasterOrderId.fbeSize), buffer, this.MasterOrderId.fbeOffset + this.MasterOrderId.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.MasterOrderId.fbeSize + this.MasterLogin.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.MasterOrderId.fbeExtra + this.MasterLogin.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSocialTradingOrderInvestorUpdate.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4168
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.MasterOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MasterOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MasterOrderId.fbeSize

    if ((fbeCurrentSize + this.MasterLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MasterLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MasterLogin.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @param {!SocialTradingOrderInvestorUpdate} fbeValue Default value, defaults is new SocialTradingOrderInvestorUpdate()
   * @returns {!SocialTradingOrderInvestorUpdate} SocialTradingOrderInvestorUpdate value
   */
  get (fbeValue = new SocialTradingOrderInvestorUpdate()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @param {!SocialTradingOrderInvestorUpdate} fbeValue SocialTradingOrderInvestorUpdate value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.MasterOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.MasterOrderId = this.MasterOrderId.get()
    } else {
      fbeValue.MasterOrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MasterOrderId.fbeSize

    if ((fbeCurrentSize + this.MasterLogin.fbeSize) <= fbeStructSize) {
      fbeValue.MasterLogin = this.MasterLogin.get()
    } else {
      fbeValue.MasterLogin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MasterLogin.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @param {!SocialTradingOrderInvestorUpdate} fbeValue SocialTradingOrderInvestorUpdate value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSocialTradingOrderInvestorUpdate}
   * @param {SocialTradingOrderInvestorUpdate} fbeValue SocialTradingOrderInvestorUpdate value
   */
  setFields (fbeValue) {
    this.MasterOrderId.set(fbeValue.MasterOrderId)
    this.MasterLogin.set(fbeValue.MasterLogin)
  }
}

export { FieldModelSocialTradingOrderInvestorUpdate };

/**
 * Fast Binary Encoding SocialTradingOrderInvestorUpdate model
 */
class SocialTradingOrderInvestorUpdateModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSocialTradingOrderInvestorUpdate(this.buffer, 4)
  }

  /**
   * Get the SocialTradingOrderInvestorUpdate model
   * @this {!SocialTradingOrderInvestorUpdateModel}
   * @returns {!FieldModelSocialTradingOrderInvestorUpdate} model SocialTradingOrderInvestorUpdate model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SocialTradingOrderInvestorUpdateModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SocialTradingOrderInvestorUpdateModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SocialTradingOrderInvestorUpdateModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SocialTradingOrderInvestorUpdateModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSocialTradingOrderInvestorUpdate.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SocialTradingOrderInvestorUpdateModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SocialTradingOrderInvestorUpdateModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SocialTradingOrderInvestorUpdateModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SocialTradingOrderInvestorUpdateModel}
   * @param {!SocialTradingOrderInvestorUpdate} value SocialTradingOrderInvestorUpdate value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SocialTradingOrderInvestorUpdateModel}
   * @param {!SocialTradingOrderInvestorUpdate} value SocialTradingOrderInvestorUpdate value, defaults is new SocialTradingOrderInvestorUpdate()
   * @return {!object} Deserialized SocialTradingOrderInvestorUpdate value and its size
   */
  deserialize (value = new SocialTradingOrderInvestorUpdate()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SocialTradingOrderInvestorUpdate(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SocialTradingOrderInvestorUpdate(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SocialTradingOrderInvestorUpdateModel}
   * @param {!number} prev Previous SocialTradingOrderInvestorUpdate model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SocialTradingOrderInvestorUpdateModel };
